<app-dialog
  [dialogType]="dialogType"
  [overflowHack]="true"
  [headerLabel]="'LABEL.ADD_EXPENSES' | translate"
  [primaryActionText]="dialogButtonText$ | async"
  [primaryActionDisabled]="(numberOfSelectedExpenses$ | async) === 0"
  [hideActions]="false"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  [primaryActionTapped]="addBulkAction"
  [primaryActionTrackingAdditionalProperties]="
    expensesMultipleSelectTrackingProperties$ | async
  "
  (onPrimaryAction)="saveSelectedExpenses()"
  (onCloseAction)="onClose()"
>
  <div id="expense-picker-dialog">
    <app-search
      class="search"
      [placeholder]="'LABEL.SEARCH' | translate"
      [actionTriggers]="searchActionTriggers$"
      (onSearchTermChange)="onSearch($event)"
    >
    </app-search>

    <app-feed
      class="feed scroll-container"
      [feed]="filteredExpenses$ | async"
      [noItemsOptions]="noExpensesOptions"
      [groupByFn]="groupByFn"
      [sortGroupsByFn]="sortGroupsByFn"
      [trackByFn]="trackByFn"
    >
      <ng-template let-expense="feedItem">
        <ng-container
          *ngIf="
            expense.merchant || ('EXPENSE.NAME' | translate) as expenseMerchant
          "
        >
          <app-picker-dialog-list-item
            [bulkActionControl]="getBulkActionControl(expense)"
            bulkActionFieldId="bulk_select_{{ expense.id }}_field"
            [showHeader]="true"
            [header]="
              expense.category
                ? expenseMerchant + ' - ' + expense.category
                : expenseMerchant
            "
            [headerIcon]="expense.file ? attachmentIcon : null"
            [description]="expense.description"
            [subDescription]="
              (expense.total | money: expense.currencyCode:expense.locale) +
              ' - ' +
              (expense.date | friendlyDate: true)
            "
            (onClickListItem)="onClickExpense(expense)"
          >
          </app-picker-dialog-list-item>
        </ng-container>
      </ng-template>
    </app-feed>

    <div *ngIf="error$ | async as error" class="error">
      <span>{{ error }}</span>
    </div>
  </div>
</app-dialog>
